import type { Svg } from "@svgdotjs/svg.js";
import { WALL_STROKE_PX, HORIZONTAL_PADDING_PX, VERTICAL_PADDING_PX } from "../constant";

export const drawRoomOutline = (
    svg: Svg,
    roomWidthMm: number,
    roomHeightMm: number,
    pixelsPerMillimeter: number,
    originX = HORIZONTAL_PADDING_PX,
    originY = VERTICAL_PADDING_PX
) => {
    svg.rect(roomWidthMm * pixelsPerMillimeter, roomHeightMm * pixelsPerMillimeter)
        .move(originX, originY)
        .fill("none")
        .stroke({ width: WALL_STROKE_PX, color: "#696969" });
};
